import {useDispatch, useSelector} from "react-redux";
import React from "react";
import {SelectedBooleanStatusType} from "../../Filters/utils";
import {selectedDangerModeSelectorMonitoring, setSelectedDangerModeMonitoring} from "../Selectors/filtersSliceMonitoring";

export const useSelectedDangerModeMonitoring = () => {
    const dispatch = useDispatch();
    const dangerMode = useSelector(selectedDangerModeSelectorMonitoring);

    const onSelectDangerMode = React.useCallback((selected: SelectedBooleanStatusType) => {
        dispatch(setSelectedDangerModeMonitoring(selected));
    }, [dispatch]);

    return {
        dangerMode,
        onSelectDangerMode,
    };
};